import React from 'react';
import { Alert, Link } from '@mui/material';
import { tenantConfig } from 'config';
import AccountPortalBannerStatus from 'store/types/AccountPortalBanner';
import styles from './AccountPortalBanner.module.scss';

interface AccountPortalBannerProps {
  banner?: AccountPortalBannerStatus;
  message?: string;
  linkLabel?: string;
  href?: string;
}

// Site-wide notice that links users to the Account Portal. The per-user AppConfig flag only
// controls visibility (shown only when bannerEnabled is explicitly true, so it stays hidden
// while loading or after a failed read); copy and the per-environment link are owned here.
const AccountPortalBanner: React.FunctionComponent<AccountPortalBannerProps> = ({
  banner,
  message = 'Your NCCER account has a new home. Manage your profile, credentials and billing in the new Account Portal.',
  linkLabel = 'Go to Account Portal',
  href = tenantConfig.accountPortalUrl,
}) => {
  if (banner?.bannerEnabled !== true) {
    return null;
  }

  return (
    <Alert
      severity={'info'}
      className={styles.alert}
      data-testid={'account-portal-banner'}
      action={
        <Link
          href={href}
          target={'_blank'}
          rel={'noopener noreferrer'}
          className={styles.link}
          underline={'always'}
          color={'inherit'}
        >
          {linkLabel}
        </Link>
      }
    >
      {message}
    </Alert>
  );
};

export default AccountPortalBanner;
